import { z } from 'zod';

export const apiErrorDetailSchema = z.object({
  property: z.string(),
  message: z.string(),
});

export type ApiErrorDetail = z.infer<typeof apiErrorDetailSchema>;

export const apiErrorSchema = z.object({
  errorCode: z.number(),
  errorMessage: z.string(),
  errors: z.array(apiErrorDetailSchema),
});

export type ApiError = z.infer<typeof apiErrorSchema>;
